import {
  ADS_CAMPAIGN_GOOGLE_BUSINESS_NAME_MAX_LENGTH,
  FONT_SIZE_BUTTON,
  GOOGLE,
  GOOGLE_IMAGE_FORMATS,
} from "../../../../utils/constants";
import { useFormContext } from "react-hook-form";
import MultiContentField from "../../../Form/MultiContentField";
import Accordion from "../../../Containers/Accordion";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE,
  IMAGES_OF_CAMPAIGN_PLACEHOLDER,
  BUSINESS_NAME_PLACEHOLDER,
  LOGO,
  BUTTON_UPLOAD_LOGO,
  BUTTON_CHANGE_LOGO,
  FIELD_REQUIRED,
} from "../../../../i18n/keysTranslations";
import ChipOptional from "../../../Chip/ChipOptional";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";
import { useDispatchApp } from "../../../../lib/redux";
import { getPathDatabaseByRole } from "../../../../actions/auth";
import CardMedia from "../../../Media/CardMedia";
import UploadFileButton from "../../../Buttons/UploadFileButton";
import TextField from "../../../Form/TextField";
import { useState } from "react";
import {
  BOX_SHADOW_FIELDS,
  INPUT_COLOR_BORDER,
} from "../../../../utils/colors";
import { Box } from "@mui/material";
import CardContainer from "../../../Card/CardContainer";

const CampaignGoogleSearchForm = ({ platform }) => {
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  const {
    watch,
    getValues,
    setValue,
    control,
    isGeneralDisabledFields,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();

  const basicPath = `platformsData.${platform}`;
  const platformsData = watch("platformsData") || {};
  const language = watch("language");
  const imageUrls = watch(`${basicPath}.imageUrls`) || [];
  const logoUrl = watch(`${basicPath}.logoUrl`);
  const { userID, pathLogoUrl, isUserPlatform } = dispatch(
    getPathDatabaseByRole()
  );
  return (
    <>
      <Grid item xs={12}>
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE)}
              </Typography>
            </Box>
          }
        >
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Grid item sx={{ mb: 4 }} xs={12}>
                <Typography variant="body1" gutterBottom>
                  {t(BUSINESS_NAME_PLACEHOLDER)}
                </Typography>
                <TextField
                  name={`${basicPath}.businessName`}
                  variant="filled"
                  fullWidth
                  disabled={isGeneralDisabledFields}
                  control={control}
                  errors={errors}
                  showCounterCharacters={true}
                  maxCharacters={ADS_CAMPAIGN_GOOGLE_BUSINESS_NAME_MAX_LENGTH}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  {t(IMAGES_OF_CAMPAIGN_PLACEHOLDER)}
                </Typography>
                <Accordion
                  title={t(IMAGES_OF_CAMPAIGN_PLACEHOLDER)}
                  actionsComponent={<ChipOptional />}
                  sx={{
                    backgroundColor: "fields.background",
                    border: `1px solid ${INPUT_COLOR_BORDER}`,
                    boxShadow: BOX_SHADOW_FIELDS,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "stretch",
                    minHeight: 70,
                  }}
                >
                  <MultiContentField
                    platform={GOOGLE}
                    language={language}
                    acceptedFormats={GOOGLE_IMAGE_FORMATS}
                    disabled={isGeneralDisabledFields}
                    showGalleryGoogleOption={true}
                    propsPostsAdsPlatforms={platformsData}
                    mediaUrls={imageUrls}
                    onChange={(contents) => {
                      const newImageUrls = contents.map(
                        (content) => content.url
                      );
                      const newValues =
                        getValues(`${basicPath}.imageUrls`) || [];
                      setValue(`${basicPath}.imageUrls`, [
                        ...newValues,
                        ...newImageUrls,
                      ]);
                    }}
                    onDelete={(index) => {
                      setValue(
                        `${basicPath}.imageUrls`,
                        imageUrls.filter((_, i) => i !== index)
                      );
                    }}
                  />
                </Accordion>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  {t(LOGO)}
                </Typography>
                {logoUrl && (
                  <CardMedia
                    url={logoUrl}
                    sx={{
                      objectFit: "cover",
                      borderRadius: 3,
                      height: 150,
                      width: 150,
                      mb: 1,
                    }}
                  />
                )}
                {!isGeneralDisabledFields && (
                  <Controller
                    name={`${basicPath}.logoUrl`}
                    control={control}
                    render={({ field }) => (
                      <UploadFileButton
                        disableVerificationMedia={true}
                        id="upload-logo-url"
                        textUpload={BUTTON_UPLOAD_LOGO}
                        colorUpload="secondary"
                        textRemove={BUTTON_CHANGE_LOGO}
                        colorRemove="secondary"
                        value={field.value}
                        onChange={(value) => {
                          const url = value?.[0];
                          field.onChange(url);
                        }}
                        pathStorage={`socialMedia/${userID}/`}
                        pathRTDB={isUserPlatform ? pathLogoUrl : null}
                        acceptedFormats={GOOGLE_IMAGE_FORMATS}
                        modeUpload="sync"
                        loading={isUploadingLogo}
                        onCallbackLoading={(loading) =>
                          setIsUploadingLogo(loading)
                        }
                        sx={{
                          fontSize: FONT_SIZE_BUTTON,
                          width: 110,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </CardContainer>
      </Grid>
    </>
  );
};

export default CampaignGoogleSearchForm;
